// gsapを読み込む
import { gsap } from 'gsap';
/********************
* 型定義
*********************/
const timeline = gsap.timeline({
    defaults: {
        duration: 2,
        yoyo: true,
        ease: "power2.inOut"
    }
})
.fromTo('.left, .right', {
    svgOrigin: "640 500",
    skewY: (i) => [-30, 15][i],
    scaleX: (i) => [.6, 0.85][i],
    x: 200
}, {
    skewY: (i) => [-15, 30][i],
    scaleX: (i) => [0.85, 0.6][i],
    x: -200
})

const timeline2 = gsap.timeline();

document.querySelectorAll('text').forEach((text, i) => {

    timeline2.add(
        gsap.fromTo(text, {
            xPercent: -100,
            x:700
        }, {
            duration: 1,
            xPercent: 0,
            x: 575,
            ease: "sine.inOut",
        })
        , i%3*.2
    )
}) 

window.onpointermove = (e) => {
    timeline.pause();
    timeline2.pause();
    gsap.to([timeline, timeline2], {
        duration: 2,
        ease: "power4",
        progress: e.x/innerWidth
    })
}
document.body.addEventListener('pointermove', (e) => {
    const {currentTarget: el, clientX: x, clientY: y} = e;
    const {top: t, left: l, width: w, height: h} = (el as Element).getBoundingClientRect();
    (el as HTMLElement).style.setProperty('--posX', `${x-l-w/2}`);
    (el as HTMLElement).style.setProperty('--posY', `${y-t-h/2}`);
})
